import { render } from "./DutyPermissions.vue?vue&type=template&id=5b5c6938&ts=true"
import script from "./DutyPermissions.vue?vue&type=script&lang=ts"
export * from "./DutyPermissions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__